import { render, staticRenderFns } from "./sort3.vue?vue&type=template&id=069ca565&scoped=true&"
import script from "./sort3.vue?vue&type=script&lang=js&"
export * from "./sort3.vue?vue&type=script&lang=js&"
import style0 from "./sort3.vue?vue&type=style&index=0&id=069ca565&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ca565",
  null
  
)

export default component.exports